import { render } from "./SdiFattureClienti.vue?vue&type=template&id=47feaff8&scoped=true"
import script from "./SdiFattureClienti.vue?vue&type=script&lang=js"
export * from "./SdiFattureClienti.vue?vue&type=script&lang=js"

import "./SdiFattureClienti.vue?vue&type=style&index=0&id=47feaff8&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47feaff8"]])

export default __exports__